"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProfileContextValue = exports.useProfileContextProvider = void 0;
const react_1 = __importDefault(require("react"));
const Api = __importStar(require("@src/api"));
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const ProfileContext = react_1.default.createContext({
    profileEmptyFields: [],
    updateProfileEmptyFields: async () => { },
});
const useProfileContextProvider = () => {
    const intl = (0, react_intl_1.useIntl)();
    const [profileEmptyFields, setProfileEmptyFields] = react_1.default.useState([]);
    async function updateProfileEmptyFields() {
        try {
            const profileEmptyFieldsResponse = await Api.Profile.getEmptyResumeFields();
            if (!(0, lodash_1.isEqual)(profileEmptyFields, profileEmptyFieldsResponse)) {
                setProfileEmptyFields(profileEmptyFieldsResponse);
            }
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'global.notification_variants.error',
                }),
                description: intl.formatMessage({
                    id: 'global.notification_variants.something_went_wrong',
                }),
            });
        }
    }
    return {
        ProfileContextProvider: ProfileContext.Provider,
        value: {
            profileEmptyFields,
            updateProfileEmptyFields,
        },
    };
};
exports.useProfileContextProvider = useProfileContextProvider;
const useProfileContextValue = () => {
    const context = react_1.default.useContext(ProfileContext);
    return context;
};
exports.useProfileContextValue = useProfileContextValue;
